import { isInboxItemAnnouncement } from './announcements';

const TICKET_TYPES = new Set([
  'ticket_created',
  'ticket_comment',
  'ticket_updated',
  'ticket_assigned',
]);

const COMPANY_MESSAGE_TYPES = new Set([
  'company_message',
  'crm_alert',
  'company_broadcast',
  'announcement',
  'team_broadcast',
]);

/**
 * @param {object | null | undefined} item
 * @returns {string | null}
 */
export function resolveTicketIdFromNotification(item) {
  if (!item || typeof item !== 'object') return null;
  const meta = item.meta && typeof item.meta === 'object' ? item.meta : {};
  const candidates = [
    meta.ticketId,
    item.ticketId,
    item.linkedTicketId,
    meta.linkedTicketId,
  ];
  for (const id of candidates) {
    if (typeof id === 'string' && id.trim()) return id.trim();
  }
  return null;
}

/**
 * @param {object | null | undefined} item
 * @returns {boolean}
 */
export function isTicketNotification(item) {
  if (!item) return false;
  const type = String(item.type || item.notificationType || '').toLowerCase();
  if (TICKET_TYPES.has(type)) return true;

  const rule = String(item.ruleCode || '').toUpperCase();
  if (rule.startsWith('TICKET_') || rule.includes('TICKET_')) return true;

  const meta = item.meta && typeof item.meta === 'object' ? item.meta : {};
  if (meta.source === 'tickets' || meta.ticketAction) return true;

  return Boolean(resolveTicketIdFromNotification(item));
}

/**
 * @param {object | null | undefined} item
 * @returns {boolean}
 */
export function isCompanyMessageNotification(item) {
  if (!item) return false;
  if (isInboxItemAnnouncement(item)) return true;

  const type = String(item.type || item.notificationType || '').toLowerCase();
  if (COMPANY_MESSAGE_TYPES.has(type)) return true;

  const rule = String(item.ruleCode || '').toUpperCase();
  if (
    rule.startsWith('CRM_') ||
    rule.startsWith('COMPANY_MESSAGE_') ||
    rule.startsWith('ANNOUNCEMENT_') ||
    rule.startsWith('TEAM_BROADCAST_') ||
    rule === 'COMPANY_BROADCAST'
  ) {
    return true;
  }

  const meta = item.meta && typeof item.meta === 'object' ? item.meta : {};
  return (
    meta.source === 'announcements' ||
    meta.source === 'communications' ||
    meta.source === 'crm' ||
    meta.inboxKind === 'announcement'
  );
}

/**
 * @param {object | null | undefined} item
 * @returns {{ kind: 'ticket', ticketId: string } | { kind: 'modal' } | { kind: 'fallback' }}
 */
export function resolveNotificationClickAction(item) {
  if (isTicketNotification(item)) {
    const ticketId = resolveTicketIdFromNotification(item);
    if (ticketId) {
      return { kind: 'ticket', ticketId };
    }
  }

  if (isCompanyMessageNotification(item)) {
    return { kind: 'modal' };
  }

  return { kind: 'fallback' };
}

/**
 * @param {object | null | undefined} item
 * @returns {string}
 */
export function notificationSenderLabel(item) {
  if (!item) return 'Unknown';
  if (isInboxItemAnnouncement(item)) {
    return item.createdByEmail || 'Company Admin';
  }
  return item.createdByEmail || item.createdByName || 'System';
}
